module.exports = __webpack_public_path__ + "img/app-4-dark.4aaaf28a.png";